import { ConnectionType } from '@/features/print/constants'
import { useCallback, useMemo } from 'react'

type ConnectionTypeOnChangeCallbacks = Record<ConnectionType, (newChecked: boolean) => void>

export const useConnectionTypeOnChangeCallbacks = (
    connectionTypes: ConnectionType[],
    fieldOnChange: (value: ConnectionType) => void
): ConnectionTypeOnChangeCallbacks => {
    const handleChange = useCallback(
        (connectionType: ConnectionType, newChecked: boolean) => {
            if (!newChecked) return

            fieldOnChange(connectionType)
        },
        [fieldOnChange]
    )

    return useMemo(() => {
        return connectionTypes.reduce((acc, connectionType) => {
            acc[connectionType] = (newChecked: boolean) => handleChange(connectionType, newChecked)

            return acc
        }, {} as ConnectionTypeOnChangeCallbacks)
    }, [handleChange, connectionTypes])
}
